import { Auth } from './pages/auth/auth';

export const App = () => <Auth />;
